import React, { FC, Fragment } from 'react';
import { Alert, AlertTitle, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const PageNotFound: FC = () => {
    const { t: translate } = useTranslation(['common']);

    return (
        <Fragment>
            <Box
                style={{
                    maxWidth: 700,
                    fontFamily: 'sans-serif',
                    margin: 'auto',
                    marginTop: 80,
                }}
            >
                <Alert severity="info">
                    <AlertTitle>
                        <h1 style={{ marginTop: 0 }}>{translate('PAGE_NOT_FOUND_TITLE')}</h1>
                    </AlertTitle>
                    <Box mb={2}>{translate('PAGE_NOT_FOUND_CONTENT')}</Box>
                    <Button component={NavLink} variant="contained" to="/orders/list">
                        {translate('BACK_TO_ORDER_LIST')}
                    </Button>
                </Alert>
            </Box>
        </Fragment>
    );
};

export default PageNotFound;
